import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { Stepper } from '@mantine/core';
import classes from './DetailStepper.module.css';
export const DetailStepper: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stepper active={2} orientation="vertical" radius={5} color="var(--text-prime)" iconSize={30} completedIcon={<Icons className="icon-pr-line-checked" fontSize={18} fw={700} />} classNames={classes} mt={{
    base: 8,
    md: 12
  }}>
      <Stepper.Step label={i18n._('blockchain processing')} description={i18n._('Updated at 8/16/2024, 4:58:39 PM. Trading on the chain usually takes some time.')} />
      <Stepper.Step label={i18n._('blockchain processing')} description={i18n._('Transaction completed')} />
    </Stepper>;
};